(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hs-shoppable-video-1-preset-1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-shoppable-video-preset-1')) {
  customElements.define('hs-shoppable-video-preset-1', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.slider = this.querySelector('.hs-shoppable-video-preset-1__slider');
      this.videos = this.querySelectorAll('.hs-shoppable-video-preset-1__video');
      this.feedbackEl = this.querySelector('.hs-shoppable-video-preset-1__live-feedback');
      
      this.btnPrev = this.querySelector('.hs-shoppable-video-preset-1__arrow--prev');
      this.btnNext = this.querySelector('.hs-shoppable-video-preset-1__arrow--next');

      // Event delegation click listener
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      // Play on hover logic
      this._onMouseOver = this.handleMouseOver.bind(this);
      this._onMouseOut = this.handleMouseOut.bind(this);
      this.addEventListener('mouseover', this._onMouseOver);
      this.addEventListener('mouseout', this._onMouseOut);
      
      // Scroll listener to toggle arrow visibility dynamically
      this._onScroll = this.toggleArrows.bind(this);
      if (this.slider) {
        this.slider.addEventListener('scroll', this._onScroll);
      }

      // Play in view logic
      if (this.cfg.autoplay_in_view && 'IntersectionObserver' in window) {
        this.initObserver();
      }
      
      // Initialize arrows state
      setTimeout(() => this.toggleArrows(), 150);

      this._ready = true;
    }
    
    initObserver() {
      const options = {
        root: this.slider || null,
        threshold: 0.6
      };
      
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {
              video.muted = true;
              video.play().catch(e => console.log('Autoplay play blocked', e));
            });
          } else {
            video.pause();
          }
        });
      }, options);
      
      this.videos.forEach(v => this.io.observe(v));
    }
    
    toggleArrows() {
      if (!this.slider || !this.btnPrev || !this.btnNext) return;
      const scrollLeft = this.slider.scrollLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      
      // Left arrow is visible if scrollLeft > 5
      if (scrollLeft > 5) {
        this.btnPrev.style.display = 'flex';
      } else {
        this.btnPrev.style.display = 'none';
      }
      
      // Right arrow is visible if scrollLeft < maxScroll - 5
      if (scrollLeft < maxScroll - 5) {
        this.btnNext.style.display = 'flex';
      } else {
        this.btnNext.style.display = 'none';
      }
    }

    handleClick(e) {
      // Prev/Next Arrows
      const arrowNext = e.target.closest('.hs-shoppable-video-preset-1__arrow--next');
      const arrowPrev = e.target.closest('.hs-shoppable-video-preset-1__arrow--prev');
      
      if (arrowNext) {
        this.scrollCarousel('next');
      } else if (arrowPrev) {
        this.scrollCarousel('prev');
      }
      
      // Video Click Play/Pause toggle
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-1__media-wrapper');
      if (mediaWrapper && !e.target.closest('.hs-shoppable-video-preset-1__thumb-wrapper')) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          if (video.paused) {
            video.play().catch(() => {
              video.muted = true;
              video.play();
            });
          } else {
            video.pause();
          }
        }
      }
      
      // Ajax Add To Cart
      const atcBtn = e.target.closest('[data-hs-atc]');
      if (atcBtn) {
        this.addToCart(atcBtn);
      }
    }
    
    handleMouseOver(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-1__media-wrapper');
      if (mediaWrapper) {
        const video = mediaWrapper.querySelector('video');
        if (video && video.paused) {
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(err => console.log('Hover play blocked', err));
          });
        }
      }
    }
    
    handleMouseOut(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-1__media-wrapper');
      if (mediaWrapper && !mediaWrapper.contains(e.relatedTarget)) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          video.pause();
        }
      }
    }
    
    scrollCarousel(direction) {
      if (!this.slider) return;
      const card = this.querySelector('.hs-shoppable-video-preset-1__card');
      if (!card) return;
      
      const scrollAmount = card.clientWidth + parseFloat(getComputedStyle(this.slider).gap || 0);
      const currentScroll = this.slider.scrollLeft;
      const newScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;
      
      this.slider.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }

    addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      
      btn.setAttribute('disabled', 'disabled');
      const originalText = btn.textContent;
      btn.textContent = '...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw new Error(err.description); });
        }
        return res.json();
      })
      .then(data => {
        // Dispatch global cart events to refresh header/drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS?.cartUpdate) {
          document.dispatchEvent(new CustomEvent(window.PUB_SUB_EVENTS.cartUpdate, {
            bubbles: true,
            detail: data
          }));
        }
        
        // Announce to accessibility tools
        if (this.feedbackEl) {
          this.feedbackEl.textContent = 'Added to cart successfully.';
        }
        
        // Behaviors based on setting
        if (this.cfg.after_add_to_cart === 'cart') {
          window.location.href = '/cart';
        } else if (this.cfg.after_add_to_cart === 'checkout') {
          window.location.href = '/checkout';
        } else {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.removeAttribute('disabled');
          }, 2000);
        }
      })
      .catch(err => {
        console.error('ATC Error:', err);
        if (this.feedbackEl) {
          this.feedbackEl.textContent = err.message || 'Failed to add product to cart.';
        }
        alert(err.message || 'Failed to add product to cart.');
        btn.textContent = originalText;
        btn.removeAttribute('disabled');
      });
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('mouseover', this._onMouseOver);
      this.removeEventListener('mouseout', this._onMouseOut);
      if (this.slider) {
        this.slider.removeEventListener('scroll', this._onScroll);
      }
      if (this.io) {
        this.io.disconnect();
      }
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-shoppable-video-1-preset-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-shoppable-video-preset-2')) {
  customElements.define('hs-shoppable-video-preset-2', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.slider = this.querySelector('.hs-shoppable-video-preset-2__slider');
      this.videos = this.querySelectorAll('.hs-shoppable-video-preset-2__video');
      this.feedbackEl = this.querySelector('.hs-shoppable-video-preset-2__live-feedback');
      
      this.btnPrev = this.querySelector('.hs-shoppable-video-preset-2__arrow--prev');
      this.btnNext = this.querySelector('.hs-shoppable-video-preset-2__arrow--next');

      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onMouseOver = this.handleMouseOver.bind(this);
      this._onMouseOut = this.handleMouseOut.bind(this);
      this.addEventListener('mouseover', this._onMouseOver);
      this.addEventListener('mouseout', this._onMouseOut);
      
      this._onScroll = this.toggleArrows.bind(this);
      if (this.slider) {
        this.slider.addEventListener('scroll', this._onScroll);
      }

      if (this.cfg.autoplay_in_view && 'IntersectionObserver' in window) {
        this.initObserver();
      }
      
      setTimeout(() => this.toggleArrows(), 150);

      this._ready = true;
    }
    
    updatePlayPauseUI(video, isPlaying) {
      const wrapper = video.closest('.hs-shoppable-video-preset-2__media-wrapper');
      if (!wrapper) return;
      const btn = wrapper.querySelector('.hs-shoppable-video-preset-2__play-pause');
      if (!btn) return;
      const playIcon = btn.querySelector('.hs-shoppable-video-preset-2__icon-play');
      const pauseIcon = btn.querySelector('.hs-shoppable-video-preset-2__icon-pause');
      if (playIcon && pauseIcon) {
        if (isPlaying) {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
          btn.setAttribute('aria-label', 'Pause video');
        } else {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
          btn.setAttribute('aria-label', 'Play video');
        }
      }
    }
    
    initObserver() {
      const options = {
        root: this.slider || null,
        threshold: 0.6
      };
      
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.dataset.manualPause === 'true') return;
            video.play().then(() => {
              this.updatePlayPauseUI(video, true);
            }).catch(() => {
              video.muted = true;
              video.play().then(() => this.updatePlayPauseUI(video, true)).catch(e => console.log('Autoplay play blocked', e));
            });
          } else {
            video.pause();
            this.updatePlayPauseUI(video, false);
          }
        });
      }, options);
      
      this.videos.forEach(v => this.io.observe(v));
    }
    
    toggleArrows() {
      if (!this.slider || !this.btnPrev || !this.btnNext) return;
      const scrollLeft = this.slider.scrollLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      
      if (scrollLeft > 5) {
        this.btnPrev.style.display = 'flex';
      } else {
        this.btnPrev.style.display = 'none';
      }
      
      if (scrollLeft < maxScroll - 5) {
        this.btnNext.style.display = 'flex';
      } else {
        this.btnNext.style.display = 'none';
      }
    }

    handleClick(e) {
      const playPauseBtn = e.target.closest('.hs-shoppable-video-preset-2__play-pause');
      if (playPauseBtn) {
        e.stopPropagation();
        const wrapper = playPauseBtn.closest('.hs-shoppable-video-preset-2__media-wrapper');
        const video = wrapper ? wrapper.querySelector('video') : null;
        if (video) {
          if (video.paused) {
            video.dataset.manualPause = 'false';
            video.play().then(() => {
              this.updatePlayPauseUI(video, true);
            }).catch(() => {
              video.muted = true;
              video.play().then(() => this.updatePlayPauseUI(video, true));
            });
          } else {
            video.dataset.manualPause = 'true';
            video.pause();
            this.updatePlayPauseUI(video, false);
          }
        }
        return;
      }

      const arrowNext = e.target.closest('.hs-shoppable-video-preset-2__arrow--next');
      const arrowPrev = e.target.closest('.hs-shoppable-video-preset-2__arrow--prev');
      
      if (arrowNext) {
        this.scrollCarousel('next');
      } else if (arrowPrev) {
        this.scrollCarousel('prev');
      }
      
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-2__media-wrapper');
      if (mediaWrapper && !e.target.closest('.hs-shoppable-video-preset-2__thumb-wrapper')) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          if (video.paused) {
            video.dataset.manualPause = 'false';
            video.play().then(() => this.updatePlayPauseUI(video, true)).catch(() => {
              video.muted = true;
              video.play().then(() => this.updatePlayPauseUI(video, true));
            });
          } else {
            video.dataset.manualPause = 'true';
            video.pause();
            this.updatePlayPauseUI(video, false);
          }
        }
      }
      
      const atcBtn = e.target.closest('[data-hs-atc]');
      if (atcBtn) {
        this.addToCart(atcBtn);
      }
    }
    
    handleMouseOver(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-2__media-wrapper');
      if (mediaWrapper) {
        const video = mediaWrapper.querySelector('video');
        if (video && video.paused) {
          video.dataset.manualPause = 'false';
          video.play().then(() => this.updatePlayPauseUI(video, true)).catch(() => {
            video.muted = true;
            video.play().then(() => this.updatePlayPauseUI(video, true));
          });
        }
      }
    }
    
    handleMouseOut(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-2__media-wrapper');
      if (mediaWrapper && !mediaWrapper.contains(e.relatedTarget)) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          video.pause();
          this.updatePlayPauseUI(video, false);
        }
      }
    }
    
    scrollCarousel(direction) {
      if (!this.slider) return;
      const card = this.querySelector('.hs-shoppable-video-preset-2__card');
      if (!card) return;
      
      const scrollAmount = card.clientWidth + parseFloat(getComputedStyle(this.slider).gap || 0);
      const currentScroll = this.slider.scrollLeft;
      const newScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;
      
      this.slider.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }

    addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      
      btn.setAttribute('disabled', 'disabled');
      const originalText = btn.textContent;
      btn.textContent = '...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw new Error(err.description); });
        }
        return res.json();
      })
      .then(data => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS?.cartUpdate) {
          document.dispatchEvent(new CustomEvent(window.PUB_SUB_EVENTS.cartUpdate, {
            bubbles: true,
            detail: data
          }));
        }
        
        if (this.feedbackEl) {
          this.feedbackEl.textContent = 'Added to cart successfully.';
        }
        
        if (this.cfg.after_add_to_cart === 'cart') {
          window.location.href = '/cart';
        } else if (this.cfg.after_add_to_cart === 'checkout') {
          window.location.href = '/checkout';
        } else {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.removeAttribute('disabled');
          }, 2000);
        }
      })
      .catch(err => {
        console.error('ATC Error:', err);
        if (this.feedbackEl) {
          this.feedbackEl.textContent = err.message || 'Failed to add product to cart.';
        }
        alert(err.message || 'Failed to add product to cart.');
        btn.textContent = originalText;
        btn.removeAttribute('disabled');
      });
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('mouseover', this._onMouseOver);
      this.removeEventListener('mouseout', this._onMouseOut);
      if (this.slider) {
        this.slider.removeEventListener('scroll', this._onScroll);
      }
      if (this.io) {
        this.io.disconnect();
      }
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-shoppable-video-1-preset-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-shoppable-video-preset-3')) {
  customElements.define('hs-shoppable-video-preset-3', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.slider = this.querySelector('.hs-shoppable-video-preset-3__slider');
      this.videos = this.querySelectorAll('.hs-shoppable-video-preset-3__video');
      this.feedbackEl = this.querySelector('.hs-shoppable-video-preset-3__live-feedback');
      
      this.btnPrev = this.querySelector('.hs-shoppable-video-preset-3__arrow--prev');
      this.btnNext = this.querySelector('.hs-shoppable-video-preset-3__arrow--next');

      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onMouseOver = this.handleMouseOver.bind(this);
      this._onMouseOut = this.handleMouseOut.bind(this);
      this.addEventListener('mouseover', this._onMouseOver);
      this.addEventListener('mouseout', this._onMouseOut);
      
      this._onScroll = this.toggleArrows.bind(this);
      if (this.slider) {
        this.slider.addEventListener('scroll', this._onScroll);
      }

      if (this.cfg.autoplay_in_view && 'IntersectionObserver' in window) {
        this.initObserver();
      }
      
      setTimeout(() => this.toggleArrows(), 150);

      this._ready = true;
    }
    
    initObserver() {
      const options = {
        root: this.slider || null,
        threshold: 0.6
      };
      
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {
              video.muted = true;
              video.play().catch(e => console.log('Autoplay play blocked', e));
            });
          } else {
            video.pause();
          }
        });
      }, options);
      
      this.videos.forEach(v => this.io.observe(v));
    }
    
    toggleArrows() {
      if (!this.slider || !this.btnPrev || !this.btnNext) return;
      const scrollLeft = this.slider.scrollLeft;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      
      if (scrollLeft > 5) {
        this.btnPrev.style.display = 'flex';
      } else {
        this.btnPrev.style.display = 'none';
      }
      
      if (scrollLeft < maxScroll - 5) {
        this.btnNext.style.display = 'flex';
      } else {
        this.btnNext.style.display = 'none';
      }
    }

    handleClick(e) {
      const arrowNext = e.target.closest('.hs-shoppable-video-preset-3__arrow--next');
      const arrowPrev = e.target.closest('.hs-shoppable-video-preset-3__arrow--prev');
      
      if (arrowNext) {
        this.scrollCarousel('next');
      } else if (arrowPrev) {
        this.scrollCarousel('prev');
      }
      
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-3__media-wrapper');
      if (mediaWrapper && !e.target.closest('.hs-shoppable-video-preset-3__thumb-wrapper')) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          if (video.paused) {
            video.play().catch(() => {
              video.muted = true;
              video.play();
            });
          } else {
            video.pause();
          }
        }
      }
      
      const atcBtn = e.target.closest('[data-hs-atc]');
      if (atcBtn) {
        this.addToCart(atcBtn);
      }
    }
    
    handleMouseOver(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-3__media-wrapper');
      if (mediaWrapper) {
        const video = mediaWrapper.querySelector('video');
        if (video && video.paused) {
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(err => console.log('Hover play blocked', err));
          });
        }
      }
    }
    
    handleMouseOut(e) {
      if (!this.cfg.hover_to_play) return;
      const mediaWrapper = e.target.closest('.hs-shoppable-video-preset-3__media-wrapper');
      if (mediaWrapper && !mediaWrapper.contains(e.relatedTarget)) {
        const video = mediaWrapper.querySelector('video');
        if (video) {
          video.pause();
        }
      }
    }
    
    scrollCarousel(direction) {
      if (!this.slider) return;
      const card = this.querySelector('.hs-shoppable-video-preset-3__card');
      if (!card) return;
      
      const scrollAmount = card.clientWidth + parseFloat(getComputedStyle(this.slider).gap || 0);
      const currentScroll = this.slider.scrollLeft;
      const newScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;
      
      this.slider.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }

    addToCart(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      
      btn.setAttribute('disabled', 'disabled');
      const originalText = btn.textContent;
      btn.textContent = '...';
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => { throw new Error(err.description); });
        }
        return res.json();
      })
      .then(data => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.PUB_SUB_EVENTS?.cartUpdate) {
          document.dispatchEvent(new CustomEvent(window.PUB_SUB_EVENTS.cartUpdate, {
            bubbles: true,
            detail: data
          }));
        }
        
        if (this.feedbackEl) {
          this.feedbackEl.textContent = 'Added to cart successfully.';
        }
        
        if (this.cfg.after_add_to_cart === 'cart') {
          window.location.href = '/cart';
        } else if (this.cfg.after_add_to_cart === 'checkout') {
          window.location.href = '/checkout';
        } else {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.removeAttribute('disabled');
          }, 2000);
        }
      })
      .catch(err => {
        console.error('ATC Error:', err);
        if (this.feedbackEl) {
          this.feedbackEl.textContent = err.message || 'Failed to add product to cart.';
        }
        alert(err.message || 'Failed to add product to cart.');
        btn.textContent = originalText;
        btn.removeAttribute('disabled');
      });
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('mouseover', this._onMouseOver);
      this.removeEventListener('mouseout', this._onMouseOut);
      if (this.slider) {
        this.slider.removeEventListener('scroll', this._onScroll);
      }
      if (this.io) {
        this.io.disconnect();
      }
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-shoppable-video-2-preset-1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-shoppable-video-2-preset-1')) {
  customElements.define('hs-shoppable-video-2-preset-1', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.slider = this.querySelector('.hs-shoppable-video-2-preset-1__slider');
      this.cards = this.querySelectorAll('.hs-shoppable-video-2-preset-1__card');
      this.btnPrev = this.querySelector('.hs-shoppable-video-2-preset-1__arrow--prev');
      this.btnNext = this.querySelector('.hs-shoppable-video-2-preset-1__arrow--next');
      this.counter = this.querySelector('.hs-shoppable-video-2-preset-1__counter');
      this.totalBlocks = this.cfg.total_blocks || this.cards.size;
      
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onScroll = this.handleScroll.bind(this);
      if (this.slider) {
        this.slider.addEventListener('scroll', this._onScroll);
      }

      this.initAutoplayObserver();
      this.syncActiveStates();

      this._ready = true;
    }
    
    initAutoplayObserver() {
      if (!this.cfg.autoplay_in_view || !('IntersectionObserver' in window)) return;
      
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView = true;
            this.playActiveVideo();
          } else {
            this.inView = false;
            this.pauseAllVideos();
          }
        });
      }, { threshold: 0.3 });
      
      this.io.observe(this);
    }
    
    syncActiveStates() {
      if (!this.slider || this.cards.length === 0) return;
      
      const scrollLeft = this.slider.scrollLeft;
      const firstCard = this.cards[0];
      const cardWidth = firstCard.clientWidth;
      const gap = parseFloat(getComputedStyle(this.slider).gap || 0);
      
      const activeIndex = Math.round(scrollLeft / (cardWidth + gap));
      
      // Update pagination text
      if (this.counter) {
        this.counter.textContent = `${activeIndex + 1} / ${this.totalBlocks}`;
      }
      
      // Toggle arrow disabled states
      if (this.btnPrev) {
        this.btnPrev.disabled = activeIndex === 0;
      }
      if (this.btnNext) {
        this.btnNext.disabled = activeIndex >= this.totalBlocks - 1;
      }
      
      // Toggle card active tags
      this.cards.forEach((card, idx) => {
        const video = card.querySelector('video');
        const playPauseBtn = card.querySelector('.hs-shoppable-video-2-preset-1__play-pause');
        
        if (idx === activeIndex) {
          card.classList.add('hs-shoppable-video-2-preset-1__card--active');
          if (video && this.inView && video.paused && !video.dataset.manualPause) {
            video.play().then(() => {
              if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-1__play-pause--playing');
            }).catch(() => {
              video.muted = true;
              video.play().then(() => {
                if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-1__play-pause--playing');
              });
            });
          }
        } else {
          card.classList.remove('hs-shoppable-video-2-preset-1__card--active');
          if (video && !video.paused) {
            video.pause();
            if (playPauseBtn) playPauseBtn.classList.remove('hs-shoppable-video-2-preset-1__play-pause--playing');
          }
        }
      });
    }
    
    playActiveVideo() {
      const activeCard = this.querySelector('.hs-shoppable-video-2-preset-1__card--active');
      if (!activeCard) return;
      const video = activeCard.querySelector('video');
      const playPauseBtn = activeCard.querySelector('.hs-shoppable-video-2-preset-1__play-pause');
      
      if (video && video.paused && !video.dataset.manualPause) {
        video.play().then(() => {
          if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-1__play-pause--playing');
        }).catch(() => {
          video.muted = true;
          video.play().then(() => {
            if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-1__play-pause--playing');
          });
        });
      }
    }
    
    pauseAllVideos() {
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        const playPauseBtn = card.querySelector('.hs-shoppable-video-2-preset-1__play-pause');
        if (video && !video.paused) {
          video.pause();
          if (playPauseBtn) playPauseBtn.classList.remove('hs-shoppable-video-2-preset-1__play-pause--playing');
        }
      });
    }

    handleScroll() {
      if (this.scrollTimeout) cancelAnimationFrame(this.scrollTimeout);
      this.scrollTimeout = requestAnimationFrame(() => {
        this.syncActiveStates();
      });
    }

    handleClick(e) {
      const arrowNext = e.target.closest('.hs-shoppable-video-2-preset-1__arrow--next');
      const arrowPrev = e.target.closest('.hs-shoppable-video-2-preset-1__arrow--prev');
      
      if (arrowNext) {
        this.scrollCarousel('next');
      } else if (arrowPrev) {
        this.scrollCarousel('prev');
      }
      
      const playPauseBtn = e.target.closest('.hs-shoppable-video-2-preset-1__play-pause');
      if (playPauseBtn) {
        const card = playPauseBtn.closest('.hs-shoppable-video-2-preset-1__card');
        const video = card.querySelector('video');
        if (video) {
          if (video.paused) {
            delete video.dataset.manualPause;
            video.play().then(() => {
              playPauseBtn.classList.add('hs-shoppable-video-2-preset-1__play-pause--playing');
            });
          } else {
            video.dataset.manualPause = 'true';
            video.pause();
            playPauseBtn.classList.remove('hs-shoppable-video-2-preset-1__play-pause--playing');
          }
        }
      }
    }
    
    scrollCarousel(direction) {
      if (!this.slider || this.cards.length === 0) return;
      const cardWidth = this.cards[0].clientWidth;
      const gap = parseFloat(getComputedStyle(this.slider).gap || 0);
      const scrollAmount = cardWidth + gap;
      
      const currentScroll = this.slider.scrollLeft;
      const newScroll = direction === 'next' 
        ? currentScroll + scrollAmount 
        : currentScroll - scrollAmount;
      
      this.slider.scrollTo({
        left: newScroll,
        behavior: 'smooth'
      });
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this.slider) {
        this.slider.removeEventListener('scroll', this._onScroll);
      }
      if (this.io) {
        this.io.disconnect();
      }
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-shoppable-video-2-preset-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-shoppable-video-2-preset-2')) {
  customElements.define('hs-shoppable-video-2-preset-2', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.slider = this.querySelector('.hs-shoppable-video-2-preset-2__slider');
      this.cards = this.querySelectorAll('.hs-shoppable-video-2-preset-2__card');
      this.totalBlocks = this.cfg.total_blocks || this.cards.size;
      
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);

      this._onScroll = this.handleScroll.bind(this);
      if (this.slider) {
        this.slider.addEventListener('scroll', this._onScroll);
      }

      this.initAutoplayObserver();
      this.syncActiveStates();

      this._ready = true;
    }
    
    initAutoplayObserver() {
      if (!this.cfg.autoplay_in_view || !('IntersectionObserver' in window)) return;
      
      this.io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView = true;
            this.playActiveVideo();
          } else {
            this.inView = false;
            this.pauseAllVideos();
          }
        });
      }, { threshold: 0.3 });
      
      this.io.observe(this);
    }
    
    syncActiveStates() {
      if (!this.slider || this.cards.length === 0) return;
      
      const scrollLeft = this.slider.scrollLeft;
      const firstCard = this.cards[0];
      const cardWidth = firstCard.clientWidth;
      const gap = parseFloat(getComputedStyle(this.slider).gap || 0);
      
      const activeIndex = Math.round(scrollLeft / (cardWidth + gap));
      
      this.cards.forEach((card, idx) => {
        const video = card.querySelector('video');
        const playPauseBtn = card.querySelector('.hs-shoppable-video-2-preset-2__play-pause');
        
        if (idx === activeIndex) {
          card.classList.add('hs-shoppable-video-2-preset-2__card--active');
          if (video && this.inView && video.paused && !video.dataset.manualPause) {
            video.play().then(() => {
              if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-2__play-pause--playing');
            }).catch(() => {
              video.muted = true;
              video.play().then(() => {
                if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-2__play-pause--playing');
              });
            });
          }
        } else {
          card.classList.remove('hs-shoppable-video-2-preset-2__card--active');
          if (video && !video.paused) {
            video.pause();
            if (playPauseBtn) playPauseBtn.classList.remove('hs-shoppable-video-2-preset-2__play-pause--playing');
          }
        }
      });
    }
    
    playActiveVideo() {
      const activeCard = this.querySelector('.hs-shoppable-video-2-preset-2__card--active');
      if (!activeCard) return;
      const video = activeCard.querySelector('video');
      const playPauseBtn = activeCard.querySelector('.hs-shoppable-video-2-preset-2__play-pause');
      
      if (video && video.paused && !video.dataset.manualPause) {
        video.play().then(() => {
          if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-2__play-pause--playing');
        }).catch(() => {
          video.muted = true;
          video.play().then(() => {
            if (playPauseBtn) playPauseBtn.classList.add('hs-shoppable-video-2-preset-2__play-pause--playing');
          });
        });
      }
    }
    
    pauseAllVideos() {
      this.cards.forEach(card => {
        const video = card.querySelector('video');
        const playPauseBtn = card.querySelector('.hs-shoppable-video-2-preset-2__play-pause');
        if (video && !video.paused) {
          video.pause();
          if (playPauseBtn) playPauseBtn.classList.remove('hs-shoppable-video-2-preset-2__play-pause--playing');
        }
      });
    }

    handleScroll() {
      if (this.scrollTimeout) cancelAnimationFrame(this.scrollTimeout);
      this.scrollTimeout = requestAnimationFrame(() => {
        this.syncActiveStates();
      });
    }

    handleClick(e) {
      const playPauseBtn = e.target.closest('.hs-shoppable-video-2-preset-2__play-pause');
      if (playPauseBtn) {
        const card = playPauseBtn.closest('.hs-shoppable-video-2-preset-2__card');
        const video = card.querySelector('video');
        if (video) {
          if (video.paused) {
            delete video.dataset.manualPause;
            video.play().then(() => {
              playPauseBtn.classList.add('hs-shoppable-video-2-preset-2__play-pause--playing');
            });
          } else {
            video.dataset.manualPause = 'true';
            video.pause();
            playPauseBtn.classList.remove('hs-shoppable-video-2-preset-2__play-pause--playing');
          }
        }
      }
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this.slider) {
        this.slider.removeEventListener('scroll', this._onScroll);
      }
      if (this.io) {
        this.io.disconnect();
      }
      this._ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-2-preset-1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-2-preset-1')) {
  customElements.define('hs-style-the-look-2-preset-1', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.cards = this.querySelectorAll('.hs-style-the-look-2-preset-1__product-card');
      
      this._onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      
      this._ready = true;
    }
    
    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._ready = false;
    }
    
    handleBlockSelect(e) {
      if (!this.contains(e.target)) return;
      const blockId = e.detail.blockId;
      const card = this.querySelector(`[data-block-id="${blockId}"]`);
      if (card) {
        // Focus scaling animation trigger for visual feedback via class
        card.classList.add('is-selected');
        setTimeout(() => {
          card.classList.remove('is-selected');
        }, 1200);
        
        // Scroll the element into view on mobile viewports
        if (window.innerWidth < 750) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-2-preset-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-2-preset-2')) {
  customElements.define('hs-style-the-look-2-preset-2', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.cards = this.querySelectorAll('.hs-style-the-look-2-preset-2__product-card');
      
      this._onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      
      this._ready = true;
    }
    
    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._ready = false;
    }
    
    handleBlockSelect(e) {
      if (!this.contains(e.target)) return;
      const blockId = e.detail.blockId;
      const card = this.querySelector(`[data-block-id="${blockId}"]`);
      if (card) {
        // Focus scaling animation trigger for visual feedback via class
        card.classList.add('is-selected');
        setTimeout(() => {
          card.classList.remove('is-selected');
        }, 1200);
        
        // Scroll the element into view on mobile viewports
        if (window.innerWidth < 750) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-2-preset-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-2-preset-3')) {
  customElements.define('hs-style-the-look-2-preset-3', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.cards = this.querySelectorAll('.hs-style-the-look-2-preset-3__product-card');
      
      this._onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      
      this._ready = true;
    }
    
    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._ready = false;
    }
    
    handleBlockSelect(e) {
      if (!this.contains(e.target)) return;
      const blockId = e.detail.blockId;
      const card = this.querySelector(`[data-block-id="${blockId}"]`);
      if (card) {
        // Focus scaling animation trigger for visual feedback via class
        card.classList.add('is-selected');
        setTimeout(() => {
          card.classList.remove('is-selected');
        }, 1200);
        
        // Scroll the element into view on mobile viewports
        if (window.innerWidth < 750) {
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-3-preset-1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-3-preset-1')) {
  customElements.define('hs-style-the-look-3-preset-1', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector('[data-hs-slider-track]');
      this.imageSlides = this.querySelectorAll('[data-hs-image-slide-index]');
      this.dots = this.querySelectorAll('[data-hs-dot-index]');
      this.btnPrev = this.querySelector('[data-hs-slider-prev]');
      this.btnNext = this.querySelector('[data-hs-slider-next]');

      if (!this.track) return;

      this.totalOriginal = this.track.children.length;
      if (this.totalOriginal > 1) {
        const firstClone = this.track.children[0].cloneNode(true);
        firstClone.setAttribute('data-hs-clone', 'true');
        firstClone.removeAttribute('data-shopify-editor-block');
        this.track.appendChild(firstClone);
      }

      this._onClickPrev = this.slidePrev.bind(this);
      this._onClickNext = this.slideNext.bind(this);
      this._onScroll = this.handleScroll.bind(this);

      this.btnPrev?.addEventListener('click', this._onClickPrev);
      this.btnNext?.addEventListener('click', this._onClickNext);
      this.track.addEventListener('scroll', this._onScroll);

      this._onDotClick = (e) => {
        const dot = e.target.closest('[data-hs-dot-index]');
        if (!dot) return;
        const index = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        this.scrollToIndex(index);
      };
      this.querySelector('[data-hs-slider-pagination]')?.addEventListener('click', this._onDotClick);

      this.updateArrows(0);
      this._ready = true;
    }

    disconnectedCallback() {
      this.btnPrev?.removeEventListener('click', this._onClickPrev);
      this.btnNext?.removeEventListener('click', this._onClickNext);
      this.track?.removeEventListener('scroll', this._onScroll);
      this.querySelector('[data-hs-slider-pagination]')?.removeEventListener('click', this._onDotClick);
      this._ready = false;
    }

    slidePrev() {
      const index = this.getCurrentIndex();
      const slideWidth = this.track.clientWidth;

      if (this.totalOriginal <= 1) return;

      if (index === 0) {
        this.track.scrollLeft = this.totalOriginal * slideWidth;
        requestAnimationFrame(() => {
          this.scrollToIndex(this.totalOriginal - 1);
        });
      } else {
        this.scrollToIndex(index - 1);
      }
    }

    slideNext() {
      const index = this.getCurrentIndex();

      if (this.totalOriginal <= 1) return;

      if (index >= this.totalOriginal) {
        this.track.scrollLeft = 0;
        requestAnimationFrame(() => {
          this.scrollToIndex(1);
        });
      } else {
        this.scrollToIndex(index + 1);
      }
    }

    scrollToIndex(index) {
      const slide = this.track.children[index];
      if (slide) {
        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });
      }
      
      this.updateActiveImage(index);
    }

    getCurrentIndex() {
      const scrollLeft = this.track.scrollLeft;
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return 0;
      return Math.round(scrollLeft / slideWidth);
    }

    handleScroll() {
      if (this.scrollTimeout) {
        window.cancelAnimationFrame(this.scrollTimeout);
      }
      this.scrollTimeout = window.requestAnimationFrame(() => {
        const scrollLeft = this.track.scrollLeft;
        const slideWidth = this.track.clientWidth;
        if (slideWidth === 0) return;

        if (this.totalOriginal <= 1) return;

        const targetCloneOffset = this.totalOriginal * slideWidth;

        // Check if we reached the clone slide at the end
        if (Math.abs(scrollLeft - targetCloneOffset) < 5) {
          this.track.scrollLeft = 0; // Jump instantly to start
          this.updateActiveDot(0);
          this.updateArrows(0);
          this.updateActiveImage(0);
          return;
        }

        const index = Math.round(scrollLeft / slideWidth);
        this.updateActiveDot(index);
        this.updateArrows(index);
        this.updateActiveImage(index);
      });
    }

    updateActiveDot(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.dots.forEach((dot) => {
        const dotIndex = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        if (dotIndex === activeIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    updateArrows(index) {
      const shouldDisable = this.totalOriginal <= 1;
      if (this.btnPrev) {
        this.btnPrev.disabled = shouldDisable;
      }
      if (this.btnNext) {
        this.btnNext.disabled = shouldDisable;
      }
    }

    updateActiveImage(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.imageSlides.forEach((slide) => {
        const slideIndex = parseInt(slide.getAttribute('data-hs-image-slide-index'), 10);
        if (slideIndex === activeIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-3-preset-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-3-preset-2')) {
  customElements.define('hs-style-the-look-3-preset-2', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector('[data-hs-slider-track]');
      this.imageSlides = this.querySelectorAll('[data-hs-image-slide-index]');
      this.dots = this.querySelectorAll('[data-hs-dot-index]');
      this.btnPrev = this.querySelector('[data-hs-slider-prev]');
      this.btnNext = this.querySelector('[data-hs-slider-next]');

      if (!this.track) return;

      this.totalOriginal = this.track.children.length;
      if (this.totalOriginal > 1) {
        const firstClone = this.track.children[0].cloneNode(true);
        firstClone.setAttribute('data-hs-clone', 'true');
        firstClone.removeAttribute('data-shopify-editor-block');
        this.track.appendChild(firstClone);
      }

      this._onClickPrev = this.slidePrev.bind(this);
      this._onClickNext = this.slideNext.bind(this);
      this._onScroll = this.handleScroll.bind(this);

      this.btnPrev?.addEventListener('click', this._onClickPrev);
      this.btnNext?.addEventListener('click', this._onClickNext);
      this.track.addEventListener('scroll', this._onScroll);

      this._onDotClick = (e) => {
        const dot = e.target.closest('[data-hs-dot-index]');
        if (!dot) return;
        const index = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        this.scrollToIndex(index);
      };
      this.querySelector('[data-hs-slider-pagination]')?.addEventListener('click', this._onDotClick);

      this.updateArrows(0);
      this._ready = true;
    }

    disconnectedCallback() {
      this.btnPrev?.removeEventListener('click', this._onClickPrev);
      this.btnNext?.removeEventListener('click', this._onClickNext);
      this.track?.removeEventListener('scroll', this._onScroll);
      this.querySelector('[data-hs-slider-pagination]')?.removeEventListener('click', this._onDotClick);
      this._ready = false;
    }

    slidePrev() {
      const index = this.getCurrentIndex();
      const slideWidth = this.track.clientWidth;

      if (this.totalOriginal <= 1) return;

      if (index === 0) {
        this.track.scrollLeft = this.totalOriginal * slideWidth;
        requestAnimationFrame(() => {
          this.scrollToIndex(this.totalOriginal - 1);
        });
      } else {
        this.scrollToIndex(index - 1);
      }
    }

    slideNext() {
      const index = this.getCurrentIndex();

      if (this.totalOriginal <= 1) return;

      if (index >= this.totalOriginal) {
        this.track.scrollLeft = 0;
        requestAnimationFrame(() => {
          this.scrollToIndex(1);
        });
      } else {
        this.scrollToIndex(index + 1);
      }
    }

    scrollToIndex(index) {
      const slide = this.track.children[index];
      if (slide) {
        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });
      }
      
      this.updateActiveImage(index);
    }

    getCurrentIndex() {
      const scrollLeft = this.track.scrollLeft;
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return 0;
      return Math.round(scrollLeft / slideWidth);
    }

    handleScroll() {
      if (this.scrollTimeout) {
        window.cancelAnimationFrame(this.scrollTimeout);
      }
      this.scrollTimeout = window.requestAnimationFrame(() => {
        const scrollLeft = this.track.scrollLeft;
        const slideWidth = this.track.clientWidth;
        if (slideWidth === 0) return;

        if (this.totalOriginal <= 1) return;

        const targetCloneOffset = this.totalOriginal * slideWidth;

        // Check if we reached the clone slide at the end
        if (Math.abs(scrollLeft - targetCloneOffset) < 5) {
          this.track.scrollLeft = 0; // Jump instantly to start
          this.updateActiveDot(0);
          this.updateArrows(0);
          this.updateActiveImage(0);
          return;
        }

        const index = Math.round(scrollLeft / slideWidth);
        this.updateActiveDot(index);
        this.updateArrows(index);
        this.updateActiveImage(index);
      });
    }

    updateActiveDot(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.dots.forEach((dot) => {
        const dotIndex = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        if (dotIndex === activeIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    updateArrows(index) {
      const shouldDisable = this.totalOriginal <= 1;
      if (this.btnPrev) {
        this.btnPrev.disabled = shouldDisable;
      }
      if (this.btnNext) {
        this.btnNext.disabled = shouldDisable;
      }
    }

    updateActiveImage(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.imageSlides.forEach((slide) => {
        const slideIndex = parseInt(slide.getAttribute('data-hs-image-slide-index'), 10);
        if (slideIndex === activeIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look-3-preset-3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look-3-preset-3')) {
  customElements.define('hs-style-the-look-3-preset-3', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.track = this.querySelector('[data-hs-slider-track]');
      this.imageSlides = this.querySelectorAll('[data-hs-image-slide-index]');
      this.dots = this.querySelectorAll('[data-hs-dot-index]');
      this.btnPrev = this.querySelector('[data-hs-slider-prev]');
      this.btnNext = this.querySelector('[data-hs-slider-next]');

      if (!this.track) return;

      this.totalOriginal = this.track.children.length;
      if (this.totalOriginal > 1) {
        const firstClone = this.track.children[0].cloneNode(true);
        firstClone.setAttribute('data-hs-clone', 'true');
        firstClone.removeAttribute('data-shopify-editor-block');
        this.track.appendChild(firstClone);
      }

      this._onClickPrev = this.slidePrev.bind(this);
      this._onClickNext = this.slideNext.bind(this);
      this._onScroll = this.handleScroll.bind(this);

      this.btnPrev?.addEventListener('click', this._onClickPrev);
      this.btnNext?.addEventListener('click', this._onClickNext);
      this.track.addEventListener('scroll', this._onScroll);

      this._onDotClick = (e) => {
        const dot = e.target.closest('[data-hs-dot-index]');
        if (!dot) return;
        const index = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        this.scrollToIndex(index);
      };
      this.querySelector('[data-hs-slider-pagination]')?.addEventListener('click', this._onDotClick);

      this.updateArrows(0);
      this._ready = true;
    }

    disconnectedCallback() {
      this.btnPrev?.removeEventListener('click', this._onClickPrev);
      this.btnNext?.removeEventListener('click', this._onClickNext);
      this.track?.removeEventListener('scroll', this._onScroll);
      this.querySelector('[data-hs-slider-pagination]')?.removeEventListener('click', this._onDotClick);
      this._ready = false;
    }

    slidePrev() {
      const index = this.getCurrentIndex();
      const slideWidth = this.track.clientWidth;

      if (this.totalOriginal <= 1) return;

      if (index === 0) {
        this.track.scrollLeft = this.totalOriginal * slideWidth;
        requestAnimationFrame(() => {
          this.scrollToIndex(this.totalOriginal - 1);
        });
      } else {
        this.scrollToIndex(index - 1);
      }
    }

    slideNext() {
      const index = this.getCurrentIndex();

      if (this.totalOriginal <= 1) return;

      if (index >= this.totalOriginal) {
        this.track.scrollLeft = 0;
        requestAnimationFrame(() => {
          this.scrollToIndex(1);
        });
      } else {
        this.scrollToIndex(index + 1);
      }
    }

    scrollToIndex(index) {
      const slide = this.track.children[index];
      if (slide) {
        this.track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });
      }
      
      this.updateActiveImage(index);
    }

    getCurrentIndex() {
      const scrollLeft = this.track.scrollLeft;
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return 0;
      return Math.round(scrollLeft / slideWidth);
    }

    handleScroll() {
      if (this.scrollTimeout) {
        window.cancelAnimationFrame(this.scrollTimeout);
      }
      this.scrollTimeout = window.requestAnimationFrame(() => {
        const scrollLeft = this.track.scrollLeft;
        const slideWidth = this.track.clientWidth;
        if (slideWidth === 0) return;

        if (this.totalOriginal <= 1) return;

        const targetCloneOffset = this.totalOriginal * slideWidth;

        // Check if we reached the clone slide at the end
        if (Math.abs(scrollLeft - targetCloneOffset) < 5) {
          this.track.scrollLeft = 0; // Jump instantly to start
          this.updateActiveDot(0);
          this.updateArrows(0);
          this.updateActiveImage(0);
          return;
        }

        const index = Math.round(scrollLeft / slideWidth);
        this.updateActiveDot(index);
        this.updateArrows(index);
        this.updateActiveImage(index);
      });
    }

    updateActiveDot(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.dots.forEach((dot) => {
        const dotIndex = parseInt(dot.getAttribute('data-hs-dot-index'), 10);
        if (dotIndex === activeIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });
    }

    updateArrows(index) {
      const shouldDisable = this.totalOriginal <= 1;
      if (this.btnPrev) {
        this.btnPrev.disabled = shouldDisable;
      }
      if (this.btnNext) {
        this.btnNext.disabled = shouldDisable;
      }
    }

    updateActiveImage(index) {
      if (this.totalOriginal <= 0) return;
      const activeIndex = index % this.totalOriginal;
      this.imageSlides.forEach((slide) => {
        const slideIndex = parseInt(slide.getAttribute('data-hs-image-slide-index'), 10);
        if (slideIndex === activeIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-style-the-look"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hs-style-the-look')) {
  customElements.define('hs-style-the-look', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      const el = this.querySelector('[data-hs-config]');
      if (!el) return;
      try { this.cfg = JSON.parse(el.textContent); } catch (e) { return; }
      
      this.dots = this.querySelectorAll('.hs-style-the-look__dot');
      this.cards = this.querySelectorAll('.hs-style-the-look__card');
      this.activeIndex = 0;
      
      this._onClick = this.handleClick.bind(this);
      this.addEventListener('click', this._onClick);
      
      this._onBlockSelect = this.handleBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      
      this.updateActiveState();
      this._ready = true;
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      this._ready = false;
    }
    
    handleClick(e) {
      const dot = e.target.closest('.hs-style-the-look__dot');
      if (dot) {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        this.setActiveIndex(index);
        return;
      }
      
      const prevBtn = e.target.closest('.hs-style-the-look__arrow--prev');
      if (prevBtn) {
        this.navigate(-1);
        return;
      }
      
      const nextBtn = e.target.closest('.hs-style-the-look__arrow--next');
      if (nextBtn) {
        this.navigate(1);
        return;
      }
    }
    
    handleBlockSelect(e) {
      if (!this.contains(e.target)) return;
      const blockId = e.detail.blockId;
      const card = this.querySelector(`[data-block-id="${blockId}"]`);
      if (card) {
        const index = parseInt(card.getAttribute('data-index'), 10);
        this.setActiveIndex(index);
      }
    }
    
    navigate(direction) {
      if (this.cards.length <= 1) return;
      let newIndex = this.activeIndex + direction;
      if (newIndex < 0) {
        newIndex = this.cards.length - 1;
      } else if (newIndex >= this.cards.length) {
        newIndex = 0;
      }
      this.setActiveIndex(newIndex);
    }
    
    setActiveIndex(index) {
      if (index === this.activeIndex || index < 0 || index >= this.cards.length) return;
      this.activeIndex = index;
      this.updateActiveState();
    }
    
    updateActiveState() {
      this.cards.forEach((card, idx) => {
        if (idx === this.activeIndex) {
          card.classList.add('hs-style-the-look__card--active');
          card.removeAttribute('aria-hidden');
        } else {
          card.classList.remove('hs-style-the-look__card--active');
          card.setAttribute('aria-hidden', 'true');
        }
      });
      
      this.dots.forEach((dot, idx) => {
        if (idx === this.activeIndex) {
          dot.classList.add('hs-style-the-look__dot--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('hs-style-the-look__dot--active');
          dot.removeAttribute('aria-current');
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
